import {useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {Foreigner} from './Foreigner'

const Step1: any = ({setIsVietNam}: any) => {
  const [formStep, setFormStep] = useState(0)
  const handleNextStep = () => {
    setIsVietNam(false)
  }

  const handleStepForForeigner = () => {
    setFormStep(1)
  }

  return (
    <>
      {formStep === 0 && (
        <div>
          <div
            className='bgi-no-repeat bgi-size-contain step1__container'
            style={{
              backgroundColor: 'rgb(235 243 243)',
            }}
          >
            <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-5'>
              <div className='mb-12'>
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/nhsv-logo-horizontal-light.svg')}
                  className='h-45px'
                />
              </div>
              <div className='w-lg-1000px bg-body rounded shadow-sm p-lg-15 mx-auto'>
                <div className='card card-containers'>
                  <div className='card-body'>
                    <div className='w-100 app-main flex-column flex-row-fluid'>
                      <div className='fv-row'>
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div
                              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex flex-column mb-5 nhsv_height'
                              style={{borderRadius: '16px'}}
                              onClick={handleNextStep}
                            >
                              <div className='d-flex justify-content-between'>
                                <img
                                  src={toAbsoluteUrl('/media/nhsv/vietnam.png')}
                                  className='nhsv_img theme-light-show'
                                  alt=''
                                />
                                <div className='mt-2'>
                                  <i className='fa fa-arrow-right fa-3x fa-right-color'></i>
                                </div>
                              </div>

                              <span className='d-block fw-bold text-start'>
                                <span className='text-dark fw-bolder d-block fs-4 mb-2'>
                                  Tôi là công dân Việt Nam
                                </span>
                                <span className='text-gray-400 fw-bold fs-6'>
                                  Quý khách vui lòng chuẩn bị CCCD còn hiệu lực để thực hiện mở tài
                                  khoản.
                                </span>
                              </span>
                            </div>
                            <div
                              className='form-text mb-6'
                              style={{fontStyle: 'italic', marginTop: 0}}
                            >
                              *Lưu ý: công dân đủ 18 tuổi trở lên mới được mở Tài khoản chứng khoán
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <div
                              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex flex-column nhsv_height'
                              style={{borderRadius: '16px'}}
                              onClick={handleStepForForeigner}
                            >
                              <div className='d-flex justify-content-between'>
                                <img
                                  src={toAbsoluteUrl('/media/nhsv/world.png')}
                                  className='nhsv_img theme-light-show'
                                  alt=''
                                />
                                <div className='mt-2'>
                                  <i className='fa fa-arrow-right fa-3x fa-right-color'></i>
                                </div>
                              </div>

                              <span className='d-block fw-bold text-start'>
                                <span className='text-dark fw-bolder d-block fs-4 mb-2'>
                                  I’m foreigner
                                </span>
                                <span className='text-gray-400 fw-bold fs-6'>
                                  Select for more details.
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* begin::Footer */}
            <div className='d-flex flex-center flex-column p-lg-8 p-sm-4'>
              <div className='fs-lg-5 nhsv_down my-3'>
                Tải ứng dụng NHSV Pro dễ dàng giao dịch chứng khoán
              </div>
              <div className='d-flex align-items-center fw-bold fs-6 mb-2 text-center'>
                <div className='text-muted text-hover-primary'>
                  <a
                    href='https://webtrading.nhsv.vn/v4/market/stock-board/'
                    target='_blank'
                    className='mx-lg-5 mx-md-3 mx-sm-1'
                    rel='noreferrer'
                  >
                    <img
                      src={toAbsoluteUrl('/media/nhsv/nhsv-web-trading.png')}
                      className='nhsv_img-footer theme-light-show'
                      alt=''
                    />
                  </a>
                </div>

                <div className='text-muted text-hover-primary'>
                  <a
                    href='https://nhsvpro.onelink.me/PZWy/webekyc'
                    target='_blank'
                    className='mx-lg-5 mx-md-3 mx-sm-1'
                    rel='noreferrer'
                  >
                    <img
                      src={toAbsoluteUrl('/media/nhsv/nhsv_ggplay.png')}
                      className='nhsv_img-footer theme-light-show'
                      alt=''
                    />
                  </a>
                </div>

                <div className='text-muted text-hover-primary'>
                  <a
                    href='https://nhsvpro.onelink.me/PZWy/webekyc'
                    target='_blank'
                    className='mx-lg-5 mx-md-3 mx-sm-1'
                    rel='noreferrer'
                  >
                    <img
                      src={toAbsoluteUrl('/media/nhsv/nhsv_appstore.png')}
                      className='nhsv_img-footer theme-light-show'
                      alt=''
                    />
                  </a>
                </div>
              </div>
            </div>
            {/* end::Footer */}
          </div>
        </div>
      )}
      {formStep === 1 && (
        <>
          <div
            className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
            style={{
              backgroundColor: 'rgb(235 243 243)',
              height: '100vh',
            }}
          >
            <div className='d-flex justify-content-start flex-column flex-column-fluid p-10 pb-lg-20'>
              <div className='mb-12 text-center'>
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/nhsv-logo-horizontal-light.svg')}
                  className='h-45px '
                />
              </div>
              <div className='w-lg-1000px bg-body rounded shadow-sm p-lg-15 mx-auto'>
                <div className='card card-containers'>
                  <div className='card-body'>
                    <Foreigner setFormStep={setFormStep} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export {Step1}
